import React from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styles from './styles';
import truckEmpty from '~/assets/dispatch/truck_empty.png';
import truckEmptyV2 from '~/assets/dispatch/truck_empty_2.png';
import truckFull from '~/assets/dispatch/truck_full.png';
import truckFullV2 from '~/assets/dispatch/truck_full_2.png';
import truckUnloading from '~/assets/dispatch/truck_unloading.png';
import excavator from '~/assets/dispatch/excavator.png';
import breaker from '~/assets/dispatch/breaker.png';
import combTruck from '~/assets/dispatch/comb_truck.png';
import tractor from '~/assets/dispatch/tractor.png';
import waterTruck from '~/assets/dispatch/water_truck.png';
import compactor from '~/assets/dispatch/compactor.png';
import perforator from '~/assets/dispatch/perforator.png';
import motorgrader from '~/assets/dispatch/motorgrader.png';
import infraLoad from '~/assets/dispatch/infra_load.png';
import steamRoller from '~/assets/dispatch/steam_roller.png';
import concreteMixer from '~/assets/dispatch/concrete_mixer.png';
import bobcat from '~/assets/dispatch/bobcat.png';
import crusher from '~/assets/dispatch/crusher.png';
import cabolt from '~/assets/dispatch/cabolt.png';
import pasteFill from '~/assets/dispatch/paste_fill.png';
import rockFill from '~/assets/dispatch/rock_fill.png';
import liftingPlataform from '~/assets/dispatch/lifting_platform.png';
import lightVehicles from '~/assets/dispatch/light_vehicles.png';
import supply from '~/assets/dispatch/supply.png';
import emulsionTruck from '~/assets/dispatch/emulsion_truck.png';
import supportTruck from '~/assets/dispatch/support_truck.png';
import drill from '~/assets/dispatch/drill.png';
import locomotive from '~/assets/dispatch/locomotive.png';
import raiseBoring from '~/assets/dispatch/raise_boring.png';
import designedRobot from '~/assets/dispatch/designed_robot.png';
import rockBolt from '~/assets/dispatch/rock_bolt.png';
import scaler from '~/assets/dispatch/scaler.png';
import shaft from '~/assets/dispatch/shaft.png';
import wagon from '~/assets/dispatch/wagon.png';
import jumbo from '~/assets/dispatch/jumbo.png';
import motorGraderV2 from '~/assets/dispatch/motor_grader_2.png';
import tractorOriginal from '~/assets/dispatch/tractor_original.png';
import fandrill from '~/assets/dispatch/fandrill.png';
import warningNovis from '~/assets/dispatch/icons/Type=OmissionWarning.svg';
import warningPause from '~/assets/dispatch/icons/Type=PauseWarning.svg';
import warningQuestion from '~/assets/dispatch/icons/Type=QuestionWarning.svg';
import warningSleep from '~/assets/dispatch/icons/Type=SleepWarning.svg';
import warningSpeed from '~/assets/dispatch/icons/Type=SpeedWarning.svg';
import warningSteering from '~/assets/dispatch/icons/Type=SteeringWarning.svg';
import warningTime from '~/assets/dispatch/icons/Type=Waiting.svg';
import warningTools from '~/assets/dispatch/icons/Type=CorrectiveMaintenance.svg';
import warningAttention from '~/assets/dispatch/icons/Warning_Icon.svg';

import material from '~/assets/dispatch/material.png';
import loader from '~/assets/dispatch/loader.png';
import loaderV2 from '~/assets/dispatch/loader_2.png';

const IMAGE_MAPPER = {
  excavator,
  truckEmpty,
  breaker,
  truckFull,
  tractor,
  motorgrader,
  waterTruck,
  truckUnloading,
  combTruck,
  compactor,
  perforator,
  material,
  loader,
  infraLoad,
  steamRoller,
  concreteMixer,
  bobcat,
  crusher,
  cabolt,
  pasteFill,
  rockFill,
  liftingPlataform,
  lightVehicles,
  supply,
  emulsionTruck,
  supportTruck,
  drill,
  locomotive,
  raiseBoring,
  designedRobot,
  rockBolt,
  scaler,
  shaft,
  wagon,
  jumbo,
  motorGraderV2,
  tractorOriginal,
  fandrill,
  truckEmptyV2,
  truckFullV2,
  loaderV2,
};

const WARNING_IMAGE_MAPPER = {
  noVisibility: warningNovis,
  pause: warningPause,
  question: warningQuestion,
  sleep: warningSleep,
  speed: warningSpeed,
  steering: warningSteering,
  time: warningTime,
  maintenance: warningTools,
  attention: warningAttention,
  attentionAnomaly: warningAttention,
};

const jsonToImageMapper = [
  { code_type_id: 0, type: 'maintenance' },
  { code_type_id: 1, type: 'pause' },
  { code_type_id: 2, type: 'attention' },
  { code_type_id: 3, type: 'pause' },
  { code_type_id: 4, type: 'pause' },
];

const DispatchStatus = {
  MA: 0,
  PO: 1,
  OP: 2,
  IN: 3,
};

const POSITION_MAPPER = {
  'top-left': { top: -5, left: -5 },
  'top-right': { top: -5, right: -5 },
  'bottom-left': { bottom: -5, left: -5 },
  'bottom-right': { bottom: -5, right: -5 },
};

const PF2MDispatchIconMaker = ({
  iconName, settings, classes, ...rest
}) => {
  const {
    iconSize, isBackground, reverse, alt, warnings, data, warningIconSize = '22px',
  } = settings;
  // get the icons
  const icons = require.context('../../assets/dispatch/icons', false, /\.svg$/);
  const dispatchCodeIcons = useSelector(
    state => state.dispatch.dispatchCodeIcons,
  );


  let fallbackCodeType = null;

  if (data) {
    fallbackCodeType = Object.prototype.hasOwnProperty.call(data, 'code_id')
      ? data?.code_id
      : DispatchStatus?.[data.status] ?? null;
  }

  const matchedIcon = Array.isArray(dispatchCodeIcons)
    ? dispatchCodeIcons.find(
      icon => icon.id_code === fallbackCodeType
      && icon.id_equip === data?.equip_type_id,
    )
    : null;

  const mappedType = jsonToImageMapper.find(
    item => item.code_type_id === matchedIcon?.id_code,
  )?.type || null;

  const matchedInfo = {
    icon_name: matchedIcon?.icon_name || null,
    svg_path: matchedIcon?.icon_name?.split('.')[0]
      ? icons.keys().find(path => path.includes(matchedIcon.icon_name.split('.')[0]))
      : null,
    type: mappedType,
  };

  const icon = IMAGE_MAPPER[iconName];

  const renderWarningIcons = () => {
    if (warnings && Array.isArray(warnings)) {
      return warnings.map((warning) => {
        const src = (() => {
          const isWarningAnomaly = warning.icon === 'attentionAnomaly';

          if (isWarningAnomaly) {
            return WARNING_IMAGE_MAPPER[warning.icon];
          }

          return matchedInfo?.svg_path
            ? icons(matchedInfo.svg_path)
            : WARNING_IMAGE_MAPPER[warning.icon] || WARNING_IMAGE_MAPPER.attentionAnomaly;
        })();

        return (
          <img
            key={`${warning.icon}-${warning.position}`}
            className={classes.icon}
            src={src}
            alt={warning.alt || 'Warning'}
            style={{
              width: warningIconSize,
              transform: reverse ? 'scaleX(-1)' : 'scaleX(1)',
              position: 'absolute',
              zIndex: 1,
              ...POSITION_MAPPER[warning.position || 'top-right'],
            }}
            {...rest}
          />
        );
      });
    }
    return null;
  };

  const renderIcon = () => {
    if (isBackground) {
      return (
        <div
          className={classes.icon}
          style={{
            backgroundImage: `url(${icon || IMAGE_MAPPER.truckEmpty})`,
            width: iconSize,
            height: 30,
            transform: reverse ? 'scaleX(-1)' : 'scaleX(1)',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center bottom',
          }}
          {...rest}
        />
      );
    }
    return (
      <img
        className={classes.icon}
        src={icon || IMAGE_MAPPER.truckEmpty}
        alt={alt || 'icon'}
        style={{
          width: iconSize,
          transform: reverse ? 'scaleX(-1)' : 'scaleX(1)',
        }}
        {...rest}
      />
    );
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {renderWarningIcons()}
      {renderIcon()}
    </div>
  );
};

PF2MDispatchIconMaker.propTypes = {
  classes: PropTypes.object,
  iconName: PropTypes.oneOf(Object.keys(IMAGE_MAPPER)),
  settings: PropTypes.shape({
    iconSize: PropTypes.number,
    isBackground: PropTypes.bool,
    reverse: PropTypes.bool,
    alt: PropTypes.string,
    data: PropTypes.object,
    warningIconSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    warnings: PropTypes.arrayOf(
      PropTypes.shape({
        icon: PropTypes.string.isRequired,
        position: PropTypes.oneOf(Object.keys(POSITION_MAPPER)),
        alt: PropTypes.string,
      }),
    ),
  }),
};

PF2MDispatchIconMaker.defaultProps = {
  classes: {},
  iconName: 'excavator',
  settings: {
    data: [],
    warnings: {},
  },
};

export default withStyles(styles)(PF2MDispatchIconMaker);
